import SummaryData from './summary-data.html';
import controller from './summary-data.controller';

let summaryDataComponent = {
  restrict: 'E',
  template: SummaryData,
  controller,
  bindings: {
    currentTimesheet: '='  // One-way data binding
  },
};

export default summaryDataComponent;



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/summary-data/summary-data.component.js